import { takeLatest, delay, buffers } from 'redux-saga'
import { put, select, call, take, actionChannel, fork } from 'redux-saga/effects'

import { localize } from 'helpers/translator'
import actionTypes from 'redux/actions/actionTypes'
import { questionSync } from 'sync'
import callAny from '../helpers/call_any'
import { creationToolMcqActions } from 'redux/actions/creationTool'
import {
	creationToolMcqSelector,
	creationToolMcqPendingRequestsSelector,
	creationToolMcqSaveValidSelector,
} from 'redux/selectors/creationTool'
import formatError from '../helpers/error_formatter'
import localErrorCodes from 'helpers/enums/errors/localErrorCodes'
import { NearpodError } from 'redux/sagas/helpers/error_formatter'

function *mcqCreateInitialize(action) {
	if (!action.activityUid) {
		return
	}
	try {
		const activityData = yield callAny(
			questionSync.get,
			action.activityUid,
			action.jwt,
		)

		yield put(creationToolMcqActions.initializeMcqSuccess(
			activityData.payload
		))
	} catch (error) {
		const serverError = formatError(error)
		yield put(creationToolMcqActions.initializeMcqError(serverError))
	}
}

function *submitQuestionChannel() {
	const eventActions = [
		actionTypes.CREATION_TOOL_MCQ_ANSWER_DELETE,
		actionTypes.CREATION_TOOL_MCQ_QUESTION_AUTOSAVE,
		actionTypes.CREATION_TOOL_MCQ_ANSWER_AUTOSAVE,
		actionTypes.CREATION_TOOL_MCQ_ANSWER_DROP,
		actionTypes.CREATION_TOOL_MCQ_ANSWER_CHECKBOX_CHANGE,
		actionTypes.CREATION_TOOL_MCQ_ANSWER_ADD,
	]
	const requestChannel = yield actionChannel(eventActions, buffers.sliding(1))

	while (true) {
		const action = yield take(requestChannel)
		try {
			yield call(mcqCreateUpdateQuestion, action)
		} catch (err) {
			// console.log(err)
		}
	}
}

function *mcqCreateUpdateQuestion(action) {
	try {
		const mcq = yield select(creationToolMcqSelector)

		const question = {
			text: mcq.question.text,
			answers: mcq.question.answers.map(answer => ({
				correct: answer.correct,
				text: answer.media.payload.text,
				uid: answer.serverId,
				media: answer.media,
			})),
		}

		const response = yield callAny(
			questionSync.update,
			mcq.activityUid,
			question,
			action.jwt,
		)
		yield put(creationToolMcqActions.questionUpdateSuccess(response.payload.answers))
	} catch (error) {
		const serverError = formatError(error)
		yield put(creationToolMcqActions.questionUpdateError(serverError))
	}
}

function *mcqSave() {
	const isValidToSave = yield select(creationToolMcqSaveValidSelector)
	if (isValidToSave) {
		let hasPendingRequests = true
		while (hasPendingRequests) {
			hasPendingRequests = yield select(creationToolMcqPendingRequestsSelector)

			if (hasPendingRequests) {
				yield call(delay, 500)
			}
		}
	} else {
		throw new NearpodError(
			localErrorCodes.GENERIC_ERROR,
			localize('global_complete_fields')
		)
	}
}

function *getMcqActivity(activityUid, jwt) {
	try {
		const activityData = yield callAny(
			questionSync.get,
			activityUid,
			jwt,
		)

		yield put(
			creationToolMcqActions.getQuestionSuccess(
				activityData.payload
			)
		)
	} catch (error) {
		const serverError = formatError(error)
		yield put(
			creationToolMcqActions.getQuestionError(
				serverError
			)
		)
	}
}

export default [
	takeLatest([
		actionTypes.INTERACTIVE_VIDEO_CREATION_MCQ_INITIALIZE,
		actionTypes.VIDEO_CREATION_MCQ_INITIALIZE,
		actionTypes.VIDEO_STANDALONE_MCQ_INITIALIZE,
	], mcqCreateInitialize),
	fork(submitQuestionChannel),
]

export {
	mcqCreateInitialize,
	mcqSave,
	getMcqActivity,
}
